<template>
  <div class="menus-item-form">
    <form @submit.stop.prevent="onSubmit">

      <form-group :validations="$v.form.name">
        <div slot-scope="{ errors, invalid }" class="menus-modal-field">
          <label>عنوان آیتم</label>
          <b-form-input type="text" v-model="form.name" placeholder="عنوان آیتم"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>
      <form-group :validations="$v.form.url">
        <div slot-scope="{ errors, invalid }" class="menus-modal-field">
          <label>آدرس اینترنتی</label>
          <menu-url-picker v-model="form.url"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group :validations="$v.form.order">
        <div slot-scope="{ errors, invalid }" class="menus-modal-field">
          <label>ترتیب</label>
          <b-form-input type="text" v-model="form.order" placeholder="ترتیب"/>
          <small class="menus-modal-help">عدد کوچک‌تر بالاتر نمایش داده می‌شود.</small>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group :validations="$v.form.preview">
        <div slot-scope="{ errors, invalid }" class="menus-modal-field">
          <label>عکس</label>

          <input id="brand-image" type="hidden" @change="onFileChange"/>

          <div id="preview" class="menus-modal-preview" v-if="form.preview">
            <img alt="" class="icon_class" :src="form.preview"/>
            <button type="button" class="menus-btn is-danger-soft" v-if="item.icon_class != null" @click="removeIcon()">
              <b-icon icon="trash"></b-icon>
              <span>حذف عکس</span>
            </button>
          </div>
          <div class="menus-modal-preview" v-else-if="item.icon_class != null">
            <button type="button" class="menus-btn is-danger-soft" @click="removeIcon()">
              <b-icon icon="trash"></b-icon>
              <span>حذف عکس</span>
            </button>
          </div>

          <b-form-file
              browse-text="انتخاب عکس"
              @change="onFileChange"
              v-model="form.image"
              placeholder="انتخاب عکس"
              drop-placeholder="انتخاب عکس"
          ></b-form-file>

          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <div class="menus-modal-field">
        <label>زیرمجموعه</label>
        <b-form-select v-model="form.parent_id" :options="makeParentOptions"/>
        <small class="menus-modal-help">برای آیتم سطح اول «هیچکدام» را انتخاب کنید.</small>
      </div>

      <div class="menus-modal-field">
        <label>دسترسی</label>
        <select class="custom-select" v-model="form.access">
          <option v-for="(item,index) in menuAccessTranslation" :value="index">{{ item }}</option>
        </select>
      </div>

      <div class="menus-modal-actions menus-modal-body-actions">
        <button type="submit" class="menus-btn is-primary" :disabled="saving">
          <b-spinner v-if="saving" small></b-spinner>
          <b-icon v-else icon="check2"></b-icon>
          <span>ثبت</span>
        </button>
        <button type="button" class="menus-btn" @click="$emit('cancel')">انصراف</button>
      </div>

    </form>
  </div>
</template>

<script>
import FormGroup from "../../validator/FormGroup";
import {required, url, numeric} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue'
import {flatMenu} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Menu";
import {menuAccessTranslation} from './MenuItemAccessTranslation'
import MenuUrlPicker from './MenuUrlPicker.vue'

export default {
  name: "MenuItemForm",
  components: {MenuUrlPicker, FormErrorsManager, FormGroup},
  props: {
    item: {
      default: () => {
        return {}
      }
    },
    mode: {
      default: 'create' // options: create_sub_item , create(root) , update
    }
  },
  data() {
    return {
      menuAccessTranslation,
      form: {
        menu_id: this.$route.params.id,
        parent_id: null,
        name: '',
        url: '',
        target: '',
        icon_class: null,
        color: '#000',
        status: 1,
        order: 1,
        access: 0,
      },
      saving: false,
      savingTimer: null
    }
  },
  computed: {
    currentMenu() {
      return this.$store.getters["Menu/getMenu"]
    },
    makeParentOptions() {
      let items = flatMenu(this.$store.getters["Menu/getMenuItems"])
      let options = [{text: "هیچکدام", value: null}]
      for (let i in items) {
        options.push({text: items[i].name, value: parseInt(items[i].id)})
      }
      return options
    },
  },
  methods: {
    flatMenu,
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.form.icon_class = file;
      this.form.preview = URL.createObjectURL(file);
    },
    removeIcon() {
      if (confirm('آیا از حذف عکس اطمینان دارد؟')) {
        this.$store.dispatch("Menu/deleteItemIcon", this.form).then((res) => {
          this.form.preview = null
          this.form.icon_class = null
        })
      }
    },
    onSubmit() {
      if (this.invalid()) {
        this.startSaving()
        if (this.mode === 'update') {
          this.$store.dispatch("Menu/updateItem", this.form)
        }
        if (['create', 'create_sub_item'].indexOf(this.mode) > -1) {
          this.$store.dispatch("Menu/createItem", this.form)
        }
      }
    },
    startSaving() {
      // store actions do not return a promise; the menu is reloaded after save
      this.saving = true
      clearTimeout(this.savingTimer)
      this.savingTimer = setTimeout(this.stopSaving, 8000)
    },
    stopSaving() {
      this.saving = false
      clearTimeout(this.savingTimer)
      this.savingTimer = null
    },
    initFormData() {
      if (this.mode === 'update') {
        this.form = {...this.form, ...this.item}
        this.form.preview = this.item.icon_class
        this.form.icon_class = null
      }
      if (this.mode === 'create_sub_item') {
        this.form.parent_id = this.item.id
      }
    }
  },
  validations: {
    form: {
      name: {required},
      url: {required,},
      order: {required, numeric},
      preview: {}
    }
  },
  watch: {
    currentMenu() {
      if (this.saving) {
        this.stopSaving()
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.savingTimer)
  },
  mounted() {
    this.initFormData()
  }
}
</script>

<style scoped>
.icon_class {
  width: 72px;
  height: 72px;
  object-fit: contain;
}
</style>
